/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-26 11:24:12
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-05-21 15:55:38
 * @FilePath: /qd-yunjing-web/src/router/modules/safety.ts
 * @Description: 这是默认设置,请设置`customMade`, BD%AE
 */
import { RouteRecordRaw } from 'vue-router';

export const configurationRoutes: RouteRecordRaw[] = [
  {
    path: '/configuration',
    name: 'configuration',
    component: () => import('@/views/configuration/index.vue'),
    meta: {
      authCodes: ['SMART_CENTER'],
      title: '组态图',
    },
  },
  {
    path: '/configuration/ht',
    name: 'configurationHT',
    component: () => import('@/views/configuration/ht.vue'),
    meta: {
      authCodes: ['SMART_CENTER'],
      title: 'ht组态图',
    },
  }
];
